<!-- Visualização normal (sem comparar versões) -->
<ng-container *ngIf="!comparingVersions">
    <div class="col-12" *ngIf="loading">
        <div class="row">
            <div class="col-12">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="!loading">
        <div class="col-6">
            <div class="dash-details-card">
                <div class="dash-details-card-header">
                    <span>Situação patrimonial e financeira</span>
                </div>

                <app-spacer [bottom]="24"></app-spacer>

                <ng-container
                    *ngIf="properties.length > 0; else emptyProperties">
                    <div>
                        <app-table-list [columns]="columns" [data]="properties"
                            [footerData]="footerData">
                        </app-table-list>
                    </div>
                </ng-container>

                <ng-template #emptyProperties>
                    <app-empty-content [isVisible]="true"
                        title="Nenhum patrimônio encontrado"
                        description="Não foi encontrado nenhum bem imóvel neste cadastro"
                        icon="/assets/images/forgot-password-icon2.png">
                    </app-empty-content>
                </ng-template>
            </div>
            <app-spacer [bottom]="24"></app-spacer>

            <div class="dash-details-card">
                <div class="dash-details-card-header"></div>
                <ng-container *ngIf="wage; else emptyWage">
                    <div class="dash-details-card-body">
                        <div class="row">
                            <div class="col-12 col-md-6"
                                *ngIf="isPj && wage.financial_position_at_pj && wage.financial_position_at_pj !== '' && wage.financial_position_at_pj !== null">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Data da fundação
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{ (wage?.financial_position_at_pj ||
                                        null) | date: 'dd/MM/yyyy' }}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        {{isPj ? 'Patrimônio líquido' :
                                        'Salário/Pró
                                        labore'}}
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{wage.wage ? formatBrl(wage.wage) :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        {{isPj ? 'Faturamento médio mensal' :
                                        'Outros
                                        Rendimentos'}}
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{wage.other_income ?
                                        formatBrl(wage.other_income) :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-template #emptyWage>
                    <div class="dash-details-card-body">
                        <app-empty-content [isVisible]="true"
                            title="Nenhum rendimento encontrado"
                            description="Não foi encontrado nenhum dado de rendimentos neste cadastro"
                            icon="/assets/images/forgot-password-icon2.png">
                        </app-empty-content>
                    </div>
                </ng-template>
            </div>
        </div>

        <div class="col-6">
            <div class="dash-details-card">
                <div class="dash-details-card-header">
                    <span>Outros Bens e Direitos</span>
                </div>

                <app-spacer [bottom]="24"></app-spacer>

                <ng-container *ngIf="others.length > 0; else emptyOthers">
                    <div>
                        <app-table-list [columns]="othersColumns"
                            [data]="others" [footerData]="othersFooterData">
                        </app-table-list>
                    </div>
                </ng-container>

                <ng-template #emptyOthers>
                    <app-empty-content [isVisible]="true"
                        title="Nenhum outro bem encontrado"
                        description="Não foi encontrado nenhum outro bem ou direito neste cadastro"
                        icon="/assets/images/forgot-password-icon2.png">
                    </app-empty-content>
                </ng-template>
            </div>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

    </div>
</ng-container>

<!-- Visualização com comparação de versões -->
<ng-container *ngIf="comparingVersions">
    <!-- Template reutilizável -->
    <ng-template #versionTemplate let-versionType="versionType">
        <div>
            <div class="dash-details-card">
                <div class="dash-details-card-header">
                    <span>Situação patrimonial e financeira</span>
                </div>

                <app-spacer [bottom]="24"></app-spacer>

                <ng-container
                    *ngIf="(versionType === 'comparing'
                            ? getPropertiesForComparison(versionType).length
                            : getPropertiesForView(versionType).length) > 0; else emptyPropertiesCompare">
                    <div>
                        <app-table-list
                            [columns]="getColumnsForView(versionType, true)"
                            [data]="versionType === 'comparing' ? getPropertiesForComparison(versionType) : getPropertiesForView(versionType)"
                            [footerData]="getFooterDataForView(versionType)">
                        </app-table-list>
                    </div>
                </ng-container>

                <ng-template #emptyPropertiesCompare>
                    <app-empty-content [isVisible]="true"
                        title="Nenhum patrimônio encontrado"
                        description="Não foi encontrado nenhum bem imóvel nesta versão"
                        icon="/assets/images/forgot-password-icon2.png">
                    </app-empty-content>
                </ng-template>
            </div>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div>
            <div class="dash-details-card">
                <div class="dash-details-card-header">
                    <span>Outros Bens e Direitos</span>
                </div>

                <app-spacer [bottom]="24"></app-spacer>

                <ng-container
                    *ngIf="(versionType === 'comparing'
                            ? getOthersForComparison(versionType).length
                            : getOthersForView(versionType).length) > 0; else emptyOthersCompare">
                    <div>
                        <app-table-list
                            [columns]="getColumnsForView(versionType, false)"
                            [data]="versionType === 'comparing' ? getOthersForComparison(versionType) : getOthersForView(versionType)"
                            [footerData]="getOthersFooterDataForView(versionType)">
                        </app-table-list>
                    </div>
                </ng-container>

                <ng-template #emptyOthersCompare>
                    <app-empty-content [isVisible]="true"
                        title="Nenhum outro bem encontrado"
                        description="Não foi encontrado nenhum outro bem ou direito nesta versão"
                        icon="/assets/images/forgot-password-icon2.png">
                    </app-empty-content>
                </ng-template>
            </div>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div>
            <div class="dash-details-card">
                <div class="dash-details-card-header"></div>
                <ng-container
                    *ngIf="getWageForView(versionType); else emptyWageCompare">
                    <div class="dash-details-card-body">
                        <div class="row">
                            <div class="col-12 col-md-6"
                                *ngIf="getIsPjForView(versionType) && getWageForView(versionType)?.financial_position_at_pj && getWageForView(versionType)?.financial_position_at_pj !== '' && getWageForView(versionType)?.financial_position_at_pj !== null">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Data da fundação
                                    </span>

                                    <span
                                        class="dash-details-card-item-title d-flex align-items-center"
                                        [ngClass]="getFieldStrikethroughClass('financial_position_at_pj', versionType)"
                                        style="gap: 6px;">
                                        <span style="flex-shrink: 0;"
                                            [innerHTML]="getWageFieldComparisonIcon('financial_position_at_pj', versionType)"></span>
                                        <span>
                                            {{
                                            (getFieldValueForDisplay('financial_position_at_pj',
                                            getWageForView(versionType)?.financial_position_at_pj,
                                            versionType) || null) | date:
                                            'dd/MM/yyyy' }}
                                        </span>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        {{getIsPjForView(versionType) ?
                                        'Patrimônio
                                        líquido' : 'Salário/Pró labore'}}
                                    </span>

                                    <span
                                        class="dash-details-card-item-title d-flex align-items-center"
                                        [ngClass]="getFieldStrikethroughClass('wage', versionType)"
                                        style="gap: 6px;">
                                        <span style="flex-shrink: 0;"
                                            [innerHTML]="getWageFieldComparisonIcon('wage', versionType)"></span>
                                        <span>{{ getFieldValueForDisplay('wage',
                                            getWageForView(versionType)?.wage,
                                            versionType) ?
                                            formatBrl(getFieldValueForDisplay('wage',
                                            getWageForView(versionType)?.wage,
                                            versionType)) : '--' }}</span>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        {{getIsPjForView(versionType) ?
                                        'Faturamento
                                        médio mensal' : 'Outros Rendimentos'}}
                                    </span>

                                    <span
                                        class="dash-details-card-item-title d-flex align-items-center"
                                        [ngClass]="getFieldStrikethroughClass('other_income', versionType)"
                                        style="gap: 6px;">
                                        <span style="flex-shrink: 0;"
                                            [innerHTML]="getWageFieldComparisonIcon('other_income', versionType)"></span>
                                        <span>{{
                                            getFieldValueForDisplay('other_income',
                                            getWageForView(versionType)?.other_income,
                                            versionType) ?
                                            formatBrl(getFieldValueForDisplay('other_income',
                                            getWageForView(versionType)?.other_income,
                                            versionType)) : '--' }}</span>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-template #emptyWageCompare>
                    <div class="dash-details-card-body">
                        <app-empty-content [isVisible]="true"
                            title="Nenhum rendimento encontrado"
                            description="Não foi encontrado nenhum dado de rendimentos nesta versão"
                            icon="/assets/images/forgot-password-icon2.png">
                        </app-empty-content>
                    </div>
                </ng-template>
            </div>
        </div>
    </ng-template>

    <div class="row">
        <!-- Versão Principal (Main) -->
        <div class="col-6">
            <ng-container *ngIf="getLoadingForView('main')">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>

            <ng-container *ngIf="!getLoadingForView('main')">
                <ng-container *ngIf="approvalService.approvalData.mainVersion">
                    <ng-container
                        *ngTemplateOutlet="versionTemplate; context: { versionType: 'main' }"></ng-container>
                </ng-container>

                <app-select-version-comparison
                    *ngIf="!approvalService.approvalData.mainVersion">
                </app-select-version-comparison>
            </ng-container>
        </div>

        <!-- Versão Comparando (Comparing) -->
        <div class="col-6">
            <ng-container *ngIf="getLoadingForView('comparing')">
                <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>

            <ng-container *ngIf="!getLoadingForView('comparing')">
                <ng-container
                    *ngIf="approvalService.approvalData.comparingVersion">
                    <ng-container
                        *ngTemplateOutlet="versionTemplate; context: { versionType: 'comparing' }"></ng-container>
                </ng-container>

                <app-select-version-comparison
                    *ngIf="!approvalService.approvalData.comparingVersion">
                </app-select-version-comparison>
            </ng-container>
        </div>
    </div>
</ng-container>